import React, { useState, useEffect } from "react";
import moment from "moment";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import GeneralSettingList from "views/pages/generalsettings/GeneralSettingList";
import UpdateLiveProgram from "views/pages/generalsettings/UpdateLiveProgram";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const GeneralSettings = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectId, setSelectId] = useState(null);
  const [generalList, setGeneralList] = useState([]);
  const [generalData, setGeneralData] = useState({});
  const [updateData, setUpdateData] = useState(null);
  const [programList, setProgramList] = useState([]);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (userData.data.user.role === "2") {
      const generalset = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(generalset[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);

  const handleOpen = (id) => {
    setSelectId(id);
    if (id) {
      const findList = generalList.find((o) => o.id === id);
      setUpdateData(findList);
    }
    setOpenModal(!openModal);
  };

  const getTodayProgramList = () => {
    const currentDate = moment(new Date()).format("yyyy-MM-DD");

    const payload = {
      pageNo: 1,
      limit: 100,
      orderBy: "ASC",
      searchText: "",
      date: currentDate,
      isFutureProgram: true,
    };
    APICall("post", payload, EndPoints.getProgramList)
      .then((response) => {
        const { results } = response.data.data;
        if (response.status === 200 && results) {
          setProgramList(results);
        } else {
          setProgramList([]);
        }
        Loader.isLoading(false);
      })
      .catch((error) => {
        Loader.isLoading(false);
        return error;
      });
  };

  useEffect(() => {
    fetchGeneralSetting();
    getTodayProgramList();
  }, []);

  const fetchGeneralSetting = () => {
    Loader.isLoading(true);

    APICall("get", "", EndPoints.getGeneralSettings)
      .then((response) => {
        const { data } = response.data;
        if (response.status === 200 && data) {
          setGeneralData(data);
          const generateData = [
            {
              id: 1,
              title: data.title,
              live_program: data.live_program,
              is_live_program: data.is_live_program,
              program_id: data.program_id,
              program_title: data.program_title,
            },
            {
              id: 2,
              title: "Show imsak",
              live_program: "",
              is_imsak: data.is_imsak,
              program_id: "",
              program_title: "",
            },
          ];

          setGeneralList(generateData);
        } else {
          setGeneralList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const handleProgramStatusChange = (status) => {
    const payload = {
      liveProgram: generalData.live_program,
      status: status,
      title: generalData.title,
      isNotification: false,
      programId: generalData.program_id,
    };
    APICall("post", payload, EndPoints.updateLiveProgram)
      .then((response) => {
        const { isError, message } = response.data;
        if (isError) {
          toast.error(message);
          return;
        }
        toast.success(message);
        fetchGeneralSetting();
      })
      .catch((error) => {
        return error;
      });
  };

  const handleUpdate = () => {
    fetchGeneralSetting();
  };

  const refreshVideo = () => {
    APICall("get", "", EndPoints.syncYoutubeVideos)
      .then((response) => {
        const { isError, message } = response.data;
        if (isError) {
          toast.error(message);
          return;
        }
        toast.success(message);
        fetchGeneralSetting();
      })
      .catch((error) => {
        return error;
      });
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            General Settings
          </Typography>
        }
        isVideo={generalList.length > 0}
        refreshVideo={refreshVideo}
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <GeneralSettingList
            handleOpen={handleOpen}
            generalList={generalList}
            handleProgramStatusChange={handleProgramStatusChange}
            permission={permission}
            role={role}
            fetchGeneralSetting={fetchGeneralSetting}
          />
        </Grid>
      )}

      {selectId && (
        <UpdateLiveProgram
          open={openModal}
          toggle={handleOpen}
          heading={"Update Live Program"}
          updateData={updateData}
          generalData={generalData}
          programList={programList}
          handleUpdate={handleUpdate}
          permission={permission}
          role={role}
        />
      )}
    </Grid>
  );
};

export default GeneralSettings;
